import apiService from './api';
import { 
  Invoice, 
  CreateInvoiceData, 
  UpdateInvoiceData, 
  InvoiceFilters, 
  GenerateInvoiceNumber 
} from '../types/invoiceTypes';

class InvoiceService {
  async getInvoices(filters?: InvoiceFilters): Promise<Invoice[]> {
    const today = new Date().toLocaleDateString('en-CA');
    const response = await apiService.get<Invoice[]>('/invoices', { 
      params: { ...filters, today } 
    });
    console.log("data:::::::::", response.data)
    return response.data;
  }

  async getInvoice(id: string): Promise<Invoice> {
    const today = new Date().toLocaleDateString('en-CA');
    const response = await apiService.get<Invoice>(`/invoices/${id}`, {
      params: { today }
    });
    return response.data;
  }

  async createInvoice(data: CreateInvoiceData): Promise<Invoice> {
    const response = await apiService.post<Invoice>('/invoices', data);
    return response.data;
  }

  async updateInvoice(id: string, data: UpdateInvoiceData): Promise<Invoice> {
    const response = await apiService.put<Invoice>(`/invoices/${id}`, data);
    console.log("response::::::", response)
    return response.data;
  }

  async deleteInvoice(id: string): Promise<void> {
    await apiService.delete(`/invoices/${id}`);
  }

  async getInvoiceStats(): Promise<{
    total: number;
    pending: number;
    paid: number;
    overdue: number;
    totalAmount: number;
  }> {
    const response = await apiService.get<{
      total: number;
      pending: number;
      paid: number;
      overdue: number;
      totalAmount: number;
    }>('/invoices/stats');
    return response.data;
  }

  async getInvoicesByCustomer(customerId: string): Promise<Invoice[]> {
    const response = await apiService.get<Invoice[]>(`/invoices/customer/${customerId}`);
    return response.data;
  }

  async updateInvoiceStatus(id: string, status: string): Promise<Invoice> {
    const response = await apiService.patch<Invoice>(`/invoices/${id}/status`, { status });
    return response.data;
  }

  async generateInvoiceNumber(invoiceDate?: string): Promise<GenerateInvoiceNumber> {
    const response = await apiService.get<GenerateInvoiceNumber>('/invoices/generate-number', {
      params: invoiceDate ? { invoice_date: invoiceDate } : undefined
    });
    return response.data;
  }

  async getInvoicesByDate(date: string): Promise<Invoice[]> {
    const response = await apiService.get<Invoice[]>('/invoices/by-date', {
      params: { date }
    });
    return response.data;
  }
}

export const invoiceService = new InvoiceService();
export default invoiceService; 
